<button type="button" class="btn" (click)="buttonClicked()" [ngClass]="'btn-' + type">
    <ng-content select="i.fa"></ng-content>
    <span [i18n]="[{target: 'innerHTML', key: labelKey}]"></span>
</button>
